import axios from 'axios';
import { Folder } from '../folders.types';
import { FolderDecisionAnnotation, FolderDecision } from './folders.types';

export async function listDecisionFolders(
  docId: string,
): Promise<{ decisionFolders: Folder[] }> {
  return (
    await axios.get('/folders/listDecisionFolders', {
      params: {
        docId,
      },
    })
  ).data;
}

export async function getFolderDecisions(
  from: number,
  folderKey: string,
  size?: number,
): Promise<FolderDecision[]> {
  return (
    await axios.get('/folders/getFolderDecisions', {
      params: { folderKey, from, size },
    })
  ).data.arrets;
}

export async function getFolderSimilarDecisions(
  folderKey: string,
): Promise<FolderDecision[]> {
  return (
    await axios.get('/getSimilarDecisionsFolder', {
      params: { folderKey },
    })
  ).data.simdecisions;
}

export function setFolderAnnotation({
  folderKey,
  annotation,
}: {
  folderKey: string;
  annotation: string;
}): void {
  axios.post('/folders/annotate', { folderKey, annotation });
}

export async function getFolderDecisionsAnnotations(
  folderKey: string,
): Promise<FolderDecisionAnnotation[]> {
  return (await axios.get(`/folders/${folderKey}/annotations`)).data;
}
